import React, { Component, Fragment } from 'react'
import { Header } from '../components'
import Footer from '../components/Footer'
import { userIsAuthenticated } from '../common/services/auth';
import constants from '../config/constants';
import Loading from '../components/Loading';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
class MainTemplate extends Component {
    constructor() {
        super();
        this.state = {
            loading: false
        }
    }
    
    componentDidMount() {
        this.setState({loading: true})

        const urlPathname = window.location.pathname 

        if (urlPathname === '/simulado-enem/') {
            if (!userIsAuthenticated()) {
                window.location.href = `${constants.SIMULADO_V2_URL}`
                this.setState({loading: false});
            }
        }
        this.setState({loading: false});
    }

    render() {
        const { children } = this.props;
        if (this.state.loading === true) {
            return (
                <Loading loading={this.state.loading}/>
            )
        } else {
            return (
                <Fragment>
                    <Header  />
                    <div id="beduka-enem-app-container" className="beduka-enem-app-container">
                        <div>
                            { children }
                        </div>
                    </div>
                    <Footer />
                </Fragment>
            )
        }
        
    }
};

export default MainTemplate

